// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"211":"component---src-pages-pizza-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"211":"792f508345ccfc050ec2","245":"ee865a8dd45d9513e7af","453":"214fb1f0c33b50dabc87","869":"eea8dc9edf9916c2078e"}[chunkId] + ".js";
};